import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PetitionEditPageData } from '../types';

import type {
	PetitionEditV2RootPageDataQuery,
	PetitionEditV2RootPageDataQueryVariables,
} from './petitionEditRootPageData.graphql';
import { PetitionEditV2RootPageData } from './petitionEditRootPageData.graphql';
import { getPetitionStrengthScore } from './petitionStrengthScore/getPetitionStrengthScore';

type PetitionEditPageDataParams = {
	slugOrId: string;
	includeUndiscoverableTags?: boolean;
};

export async function getPetitionEditPageData(
	utilityContext: UtilityContext,
	{ slugOrId, includeUndiscoverableTags }: PetitionEditPageDataParams,
): Promise<PetitionEditPageData> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { data } = await fetch<PetitionEditV2RootPageDataQuery, PetitionEditV2RootPageDataQueryVariables>({
		query: PetitionEditV2RootPageData,
		variables: { slugOrId, includeUndiscoverableTags },
		rejectOnError: true,
	});

	if (!data.petition) {
		throw new NotFoundError();
	}

	return {
		petition: data.petition,
		viewer: data.viewer,
		featureConfigs: data.featureConfigs,
		score: getPetitionStrengthScore(data.petition),
	};
}
